import './crystalview/style';
import FormStructure from './crystalview/form_structure';

export default FormStructure;